module.exports = __webpack_public_path__ + "static/img/monkey_successed.30599cd.png";


//////////////////
// WEBPACK FOOTER
// ./common/assets/img/monkey_successed.png
// module id = Ta6W
// module chunks = 1